
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq-pusat-bantuan",
      function () {
        return require("private-next-pages/faq-pusat-bantuan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq-pusat-bantuan"])
      });
    }
  